/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PasswordResetError {
    WEAK_PASSWORD = 'WeakPassword',
    INVALID_TOKEN = 'InvalidToken',
}
